import { api } from './api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apartmentAdminDeleteApartmentUserById: build.mutation<
      ApartmentAdminDeleteApartmentUserByIdApiResponse,
      ApartmentAdminDeleteApartmentUserByIdApiArg
    >({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users/${queryArg.userId}`,
      }),
    }),
    bulkCreateLoginLessUser: build.mutation<BulkCreateLoginLessUserApiResponse, BulkCreateLoginLessUserApiArg>({
      query: (queryArg) => ({
        body: queryArg.loginLessUserBulkRequest,
        method: 'POST',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/bulk-login-less`,
      }),
    }),
    checkUserExistenceInSiteOfApartment: build.mutation<
      CheckUserExistenceInSiteOfApartmentApiResponse,
      CheckUserExistenceInSiteOfApartmentApiArg
    >({
      query: (queryArg) => ({
        method: 'HEAD',
        params: { email: queryArg.email },
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users`,
      }),
    }),
    countContactButtonsForDevice: build.query<
      CountContactButtonsForDeviceApiResponse,
      CountContactButtonsForDeviceApiArg
    >({
      query: (queryArg) => ({
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/contact-buttons/count`,
      }),
    }),
    createGuestAndAssignPinInApartment: build.mutation<
      CreateGuestAndAssignPinInApartmentApiResponse,
      CreateGuestAndAssignPinInApartmentApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.createGuestAssignPinRequest,
        method: 'POST',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/create-guest-assign-pin`,
      }),
    }),
    createGuestAndAssignPinInSite: build.mutation<
      CreateGuestAndAssignPinInSiteApiResponse,
      CreateGuestAndAssignPinInSiteApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.createGuestAssignPinRequest,
        method: 'POST',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/create-guest-assign-pin`,
      }),
    }),
    createGuestPinWithoutAccess: build.query<CreateGuestPinWithoutAccessApiResponse, CreateGuestPinWithoutAccessApiArg>(
      {
        query: (queryArg) => ({
          url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/credentials/available-guest-pin`,
        }),
      }
    ),
    createLoginLessAndAssignPinInApartment: build.mutation<
      CreateLoginLessAndAssignPinInApartmentApiResponse,
      CreateLoginLessAndAssignPinInApartmentApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.createLoginLessAssignPinRequest,
        method: 'POST',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/create-user-with-pin`,
      }),
    }),
    createPinProposalForUser: build.mutation<CreatePinProposalForUserApiResponse, CreatePinProposalForUserApiArg>({
      query: (queryArg) => ({
        method: 'POST',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users/${queryArg.userId}/credentials/pin`,
      }),
    }),
    createPinWithoutAccess: build.query<CreatePinWithoutAccessApiResponse, CreatePinWithoutAccessApiArg>({
      query: (queryArg) => ({
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/credentials/available-pin`,
      }),
    }),
    createSite: build.mutation<CreateSiteApiResponse, CreateSiteApiArg>({
      query: (queryArg) => ({
        body: queryArg.createSiteRequest,
        method: 'POST',
        url: `/fe/companies/${queryArg.companyId}/sites`,
      }),
    }),
    createSiteContact: build.mutation<CreateSiteContactApiResponse, CreateSiteContactApiArg>({
      query: (queryArg) => ({
        body: queryArg.coreEntityContact,
        method: 'POST',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/contacts`,
      }),
    }),
    createSiteUser: build.mutation<CreateSiteUserApiResponse, CreateSiteUserApiArg>({
      query: (queryArg) => ({
        body: queryArg.siteUserRequestImpl,
        method: 'POST',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users`,
      }),
    }),
    createStandardUserInApartmentOfApartmentAdmin: build.mutation<
      CreateStandardUserInApartmentOfApartmentAdminApiResponse,
      CreateStandardUserInApartmentOfApartmentAdminApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.createUserInApartmentAsApartmentAdminRequest,
        method: 'POST',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/create-standard-user`,
      }),
    }),
    createUpdateContactButtonsForDevice: build.mutation<
      CreateUpdateContactButtonsForDeviceApiResponse,
      CreateUpdateContactButtonsForDeviceApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.callSettingsRequest,
        method: 'POST',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/contact-buttons`,
      }),
    }),
    deleteApartmentUserById: build.mutation<DeleteApartmentUserByIdApiResponse, DeleteApartmentUserByIdApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users/${queryArg.userId}`,
      }),
    }),
    deleteContactButtonsOfDevice: build.mutation<
      DeleteContactButtonsOfDeviceApiResponse,
      DeleteContactButtonsOfDeviceApiArg
    >({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/contact-buttons/${queryArg.linkingId}`,
      }),
    }),
    deleteSiteContactById: build.mutation<DeleteSiteContactByIdApiResponse, DeleteSiteContactByIdApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/contacts/${queryArg.contactId}`,
      }),
    }),
    deleteSiteUserById: build.mutation<DeleteSiteUserByIdApiResponse, DeleteSiteUserByIdApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}`,
      }),
    }),
    disableAppAccessAsAa: build.mutation<DisableAppAccessAsAaApiResponse, DisableAppAccessAsAaApiArg>({
      query: (queryArg) => ({
        method: 'POST',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users/${queryArg.userId}/credentials/bluetooth/disable`,
      }),
    }),
    editGuestInApartment: build.mutation<EditGuestInApartmentApiResponse, EditGuestInApartmentApiArg>({
      query: (queryArg) => ({
        body: queryArg.editGuestRequest,
        method: 'PUT',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/edit-guest/${queryArg.userId}`,
      }),
    }),
    editGuestInSite: build.mutation<EditGuestInSiteApiResponse, EditGuestInSiteApiArg>({
      query: (queryArg) => ({
        body: queryArg.editGuestRequest,
        method: 'PUT',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/edit-guest/${queryArg.userId}`,
      }),
    }),
    elevatorIntegrationFloorMapping: build.query<
      ElevatorIntegrationFloorMappingApiResponse,
      ElevatorIntegrationFloorMappingApiArg
    >({
      query: (queryArg) => ({
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/elevator-integration/floor-mapping`,
      }),
    }),
    enableAppAccessAsAa: build.mutation<EnableAppAccessAsAaApiResponse, EnableAppAccessAsAaApiArg>({
      query: (queryArg) => ({
        method: 'POST',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users/${queryArg.userId}/credentials/bluetooth/enable`,
      }),
    }),
    getAllUserCompletedSurveyNames: build.query<
      GetAllUserCompletedSurveyNamesApiResponse,
      GetAllUserCompletedSurveyNamesApiArg
    >({
      query: () => ({ url: `/fe/users/current/surveys` }),
    }),
    getApartmentDetailForAa: build.query<GetApartmentDetailForAaApiResponse, GetApartmentDetailForAaApiArg>({
      query: (queryArg) => ({
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}`,
      }),
    }),
    getApartmentUserForAaById: build.query<GetApartmentUserForAaByIdApiResponse, GetApartmentUserForAaByIdApiArg>({
      query: (queryArg) => ({
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users/${queryArg.userId}`,
      }),
    }),
    getCreditCostUntilEndOfMonth: build.query<
      GetCreditCostUntilEndOfMonthApiResponse,
      GetCreditCostUntilEndOfMonthApiArg
    >({
      query: (queryArg) => ({
        params: { licencesCount: queryArg.licencesCount },
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/services/MOBILE_VIDEO/licence/standardModel/creditCostUntilEndOfMonth`,
      }),
    }),
    getDefault: build.query<GetDefaultApiResponse, GetDefaultApiArg>({
      query: () => ({ url: `/fe/banners/default` }),
    }),
    getDevicesWithBleSupported: build.query<GetDevicesWithBleSupportedApiResponse, GetDevicesWithBleSupportedApiArg>({
      query: (queryArg) => ({ url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/ble-devices` }),
    }),
    getSite: build.query<GetSiteApiResponse, GetSiteApiArg>({
      query: (queryArg) => ({ url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}` }),
    }),
    getSiteBasicInfoList: build.query<GetSiteBasicInfoListApiResponse, GetSiteBasicInfoListApiArg>({
      query: (queryArg) => ({ url: `/fe/companies/${queryArg.companyId}/users/current/sites-basic-info` }),
    }),
    getSiteFeatures: build.query<GetSiteFeaturesApiResponse, GetSiteFeaturesApiArg>({
      query: (queryArg) => ({ url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/features` }),
    }),
    getSiteTypeChangePrecheck: build.query<GetSiteTypeChangePrecheckApiResponse, GetSiteTypeChangePrecheckApiArg>({
      query: (queryArg) => ({
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/change-type-precheck/${queryArg.siteType}`,
      }),
    }),
    getSiteUserById: build.query<GetSiteUserByIdApiResponse, GetSiteUserByIdApiArg>({
      query: (queryArg) => ({
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}`,
      }),
    }),
    getUnlockOverApiForDevice: build.query<GetUnlockOverApiForDeviceApiResponse, GetUnlockOverApiForDeviceApiArg>({
      query: (queryArg) => ({
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/services/ACCESS_CONTROL/unlockOverApi`,
      }),
    }),
    listApartmentUsers: build.query<ListApartmentUsersApiResponse, ListApartmentUsersApiArg>({
      query: (queryArg) => ({
        params: { filter: queryArg.filter, limit: queryArg.limit, offset: queryArg.offset, order: queryArg.order },
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users`,
      }),
    }),
    listApartmentUsersByApartmentAdminGroupedByApartment: build.query<
      ListApartmentUsersByApartmentAdminGroupedByApartmentApiResponse,
      ListApartmentUsersByApartmentAdminGroupedByApartmentApiArg
    >({
      query: () => ({ url: `/fe/apartment-admin/users-in-apartments` }),
    }),
    listContactButtonsForDevice: build.query<ListContactButtonsForDeviceApiResponse, ListContactButtonsForDeviceApiArg>(
      {
        query: (queryArg) => ({
          params: { limit: queryArg.limit, minIndex: queryArg.minIndex },
          url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/contact-buttons`,
        }),
      }
    ),
    listGroupUsers: build.query<ListGroupUsersApiResponse, ListGroupUsersApiArg>({
      query: (queryArg) => ({
        params: { limit: queryArg.limit, offset: queryArg.offset, order: queryArg.order },
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/groups/${queryArg.groupId}/users`,
      }),
    }),
    listSiteUsers: build.query<ListSiteUsersApiResponse, ListSiteUsersApiArg>({
      query: (queryArg) => ({
        params: { filter: queryArg.filter, limit: queryArg.limit, offset: queryArg.offset, order: queryArg.order },
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users`,
      }),
    }),
    listSiteUsersWithGroups: build.query<ListSiteUsersWithGroupsApiResponse, ListSiteUsersWithGroupsApiArg>({
      query: (queryArg) => ({ url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users-with-groups` }),
    }),
    markSurveyAsAnsweredForUser: build.mutation<
      MarkSurveyAsAnsweredForUserApiResponse,
      MarkSurveyAsAnsweredForUserApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.userAnsweredSurveyRequest,
        method: 'POST',
        url: `/fe/users/current/surveys`,
      }),
    }),
    migrateUserAsApartmentAdmin: build.mutation<
      MigrateUserAsApartmentAdminApiResponse,
      MigrateUserAsApartmentAdminApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.userNameWithEmail,
        method: 'POST',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users/${queryArg.userId}/migrate-user`,
      }),
    }),
    migrateUserWithAppAccessActivation: build.mutation<
      MigrateUserWithAppAccessActivationApiResponse,
      MigrateUserWithAppAccessActivationApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.userNameWithEmail,
        method: 'POST',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users/${queryArg.userId}/migrate-user-with-app-access-activation`,
      }),
    }),
    migrateUserWithDeviceActivation: build.mutation<
      MigrateUserWithDeviceActivationApiResponse,
      MigrateUserWithDeviceActivationApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.userNameWithEmail,
        method: 'POST',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users/${queryArg.userId}/migrate-user-with-device-activation`,
      }),
    }),
    modifySiteUserById: build.mutation<ModifySiteUserByIdApiResponse, ModifySiteUserByIdApiArg>({
      query: (queryArg) => ({
        body: queryArg.siteUserWithLocaleRequest,
        method: 'PUT',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/users/${queryArg.userId}`,
      }),
    }),
    notifyUserMfaEnabled: build.mutation<NotifyUserMfaEnabledApiResponse, NotifyUserMfaEnabledApiArg>({
      query: () => ({ method: 'POST', url: `/fe/users/current/mfa` }),
    }),
    setDeviceUnlockOverApiService: build.mutation<
      SetDeviceUnlockOverApiServiceApiResponse,
      SetDeviceUnlockOverApiServiceApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.setDeviceUnlockOverApiServiceRequest,
        method: 'PUT',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/devices/${queryArg.deviceId}/services/ACCESS_CONTROL/unlockOverApi`,
      }),
    }),
    updateApartmentLabel: build.mutation<UpdateApartmentLabelApiResponse, UpdateApartmentLabelApiArg>({
      query: (queryArg) => ({
        body: queryArg.apartmentLabelRequest,
        method: 'PUT',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/apartment-label`,
      }),
    }),
    updateSite: build.mutation<UpdateSiteApiResponse, UpdateSiteApiArg>({
      query: (queryArg) => ({
        body: queryArg.updateSiteRequest,
        method: 'PUT',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}`,
      }),
    }),
    updateSiteContactById: build.mutation<UpdateSiteContactByIdApiResponse, UpdateSiteContactByIdApiArg>({
      query: (queryArg) => ({
        body: queryArg.coreEntityContact,
        method: 'PUT',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/contacts/${queryArg.contactId}`,
      }),
    }),
    updateSiteCredentials: build.mutation<UpdateSiteCredentialsApiResponse, UpdateSiteCredentialsApiArg>({
      query: (queryArg) => ({
        body: queryArg.patchSiteCredentialsRequest,
        method: 'PATCH',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/credentials`,
      }),
    }),
    updateUserBasicInfoInApartment: build.mutation<
      UpdateUserBasicInfoInApartmentApiResponse,
      UpdateUserBasicInfoInApartmentApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.userModifyNameRequest,
        method: 'PUT',
        url: `/fe/apartment-admin/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/users/${queryArg.userId}`,
      }),
    }),
    validateNewHipmoDeviceInApartment: build.mutation<
      ValidateNewHipmoDeviceInApartmentApiResponse,
      ValidateNewHipmoDeviceInApartmentApiArg
    >({
      query: (queryArg) => ({
        method: 'HEAD',
        url: `/fe/companies/${queryArg.companyId}/sites/${queryArg.siteId}/apartments/${queryArg.apartmentId}/validate-new-hipmo-device`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as be4feApi };
export type GetSiteUserByIdApiResponse = /** status 200 successful operation */ SiteUserWithLocaleResponse;
export type GetSiteUserByIdApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** id of the User to perform action with. */
  userId: number;
};
export type ModifySiteUserByIdApiResponse = /** status 200 successful operation */ SiteUserWithLocaleResponse;
export type ModifySiteUserByIdApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** id of the User to perform action with. */
  userId: number;
  siteUserWithLocaleRequest: SiteUserWithLocaleRequest;
};
export type DeleteSiteUserByIdApiResponse = unknown;
export type DeleteSiteUserByIdApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** id of the User to perform action with. */
  userId: number;
};
export type EditGuestInSiteApiResponse = unknown;
export type EditGuestInSiteApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** id of the User to perform action with. */
  userId: number;
  editGuestRequest: EditGuestRequest;
};
export type GetUnlockOverApiForDeviceApiResponse =
  /** status 200 status of Unlock over API service of the device */ DeviceUnlockOverApiResponse;
export type GetUnlockOverApiForDeviceApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric id of a Device to perform action with. */
  deviceId: number;
};
export type SetDeviceUnlockOverApiServiceApiResponse = unknown;
export type SetDeviceUnlockOverApiServiceApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric id of a Device to perform action with. */
  deviceId: number;
  setDeviceUnlockOverApiServiceRequest: SetDeviceUnlockOverApiServiceRequest;
};
export type UpdateSiteContactByIdApiResponse = /** status 200 successful operation */ ContactResponse;
export type UpdateSiteContactByIdApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Id for contact */
  contactId: number;
  coreEntityContact: CoreEntityContact;
};
export type DeleteSiteContactByIdApiResponse = unknown;
export type DeleteSiteContactByIdApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Id for contact */
  contactId: number;
};
export type GetSiteApiResponse = /** status 200 successful operation */ SiteWithAcCredentialsSettingsResponse;
export type GetSiteApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
};
export type UpdateSiteApiResponse = /** status 200 successful operation */ CoreSite;
export type UpdateSiteApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  updateSiteRequest: UpdateSiteRequest;
};
export type GetApartmentUserForAaByIdApiResponse =
  /** status 200 successful operation */ SiteUserWithLocaleAndApartmentResponse;
export type GetApartmentUserForAaByIdApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** id of the User to perform action with. */
  userId: number;
};
export type UpdateUserBasicInfoInApartmentApiResponse =
  /** status 200 successful operation */ UpdateUserBasicInfoInApartmentResponse;
export type UpdateUserBasicInfoInApartmentApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** id of the User to perform action with. */
  userId: number;
  userModifyNameRequest: UserModifyNameRequest;
};
export type ApartmentAdminDeleteApartmentUserByIdApiResponse = unknown;
export type ApartmentAdminDeleteApartmentUserByIdApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** id of the User to perform action with. */
  userId: number;
};
export type EditGuestInApartmentApiResponse = unknown;
export type EditGuestInApartmentApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** id of the User to perform action with. */
  userId: number;
  editGuestRequest: EditGuestRequest;
};
export type UpdateApartmentLabelApiResponse = unknown;
export type UpdateApartmentLabelApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  apartmentLabelRequest: ApartmentLabelRequest;
};
export type GetAllUserCompletedSurveyNamesApiResponse =
  /** status 200 successful operation */ UserCompletedSurveysResponse;
export type GetAllUserCompletedSurveyNamesApiArg = void;
export type MarkSurveyAsAnsweredForUserApiResponse = unknown;
export type MarkSurveyAsAnsweredForUserApiArg = {
  userAnsweredSurveyRequest: UserAnsweredSurveyRequest;
};
export type NotifyUserMfaEnabledApiResponse = unknown;
export type NotifyUserMfaEnabledApiArg = void;
export type ListSiteUsersApiResponse = /** status 200 successful operation */ SiteUserList;
export type ListSiteUsersApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Text to filter the results with. Filter columns [id, uuid, email, firstName, lastName] */
  filter?: string;
  /** Maximum number of records to be returned. Default 50, maximum 5000 */
  limit?: number;
  /** Name of the attribute to sort the results with. If it is prepended with '-', the order is reversed. Order columns [name, email, firstName, lastName, dateCreated, enabled]  */
  order?: string[];
  /** Return the results with this offset, first record has zero offset. */
  offset?: number;
};
export type CreateSiteUserApiResponse = /** status 200 successful operation */ SiteUserWithLocaleResponse;
export type CreateSiteUserApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  siteUserRequestImpl: SiteUserRequestImpl;
};
export type ListContactButtonsForDeviceApiResponse =
  /** status 200 list of buttons with contacts */ ButtonsWithContactsResponse;
export type ListContactButtonsForDeviceApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric id of a Device to perform action with. */
  deviceId: number;
  /** Maximum number of records to be returned. Default 50, maximum 1000 */
  limit?: number;
  /** Minimum button index */
  minIndex?: number;
};
export type CreateUpdateContactButtonsForDeviceApiResponse =
  /** status 200 created or updated buttons with contacts */ ButtonWithContactsResponse;
export type CreateUpdateContactButtonsForDeviceApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric id of a Device to perform action with. */
  deviceId: number;
  callSettingsRequest: CallSettingsRequest;
};
export type CreateGuestAndAssignPinInSiteApiResponse = unknown;
export type CreateGuestAndAssignPinInSiteApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  createGuestAssignPinRequest: CreateGuestAssignPinRequest;
};
export type CreateSiteContactApiResponse = /** status 201 successful operation */ ContactResponse;
export type CreateSiteContactApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  coreEntityContact: CoreEntityContact;
};
export type BulkCreateLoginLessUserApiResponse = unknown;
export type BulkCreateLoginLessUserApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  loginLessUserBulkRequest: LoginLessUserBulkRequest;
};
export type CreateSiteApiResponse = /** status 201 successful operation */ CoreSite;
export type CreateSiteApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  createSiteRequest: CreateSiteRequest;
};
export type MigrateUserWithDeviceActivationApiResponse =
  /** status 201 successful operation */ SiteUserWithLocaleAndApartmentResponse;
export type MigrateUserWithDeviceActivationApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** id of the User to perform action with. */
  userId: number;
  userNameWithEmail: UserNameWithEmail;
};
export type MigrateUserWithAppAccessActivationApiResponse =
  /** status 201 successful operation */ SiteUserWithLocaleAndApartmentResponse;
export type MigrateUserWithAppAccessActivationApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** id of the User to perform action with. */
  userId: number;
  userNameWithEmail: UserNameWithEmail;
};
export type MigrateUserAsApartmentAdminApiResponse =
  /** status 201 successful operation */ SiteUserWithLocaleAndApartmentResponse;
export type MigrateUserAsApartmentAdminApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** id of the User to perform action with. */
  userId: number;
  userNameWithEmail: UserNameWithEmail;
};
export type CreatePinProposalForUserApiResponse = /** status 200 Generated PIN */ PinDto;
export type CreatePinProposalForUserApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** id of the User to perform action with. */
  userId: number;
};
export type EnableAppAccessAsAaApiResponse = unknown;
export type EnableAppAccessAsAaApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** id of the User to perform action with. */
  userId: number;
};
export type DisableAppAccessAsAaApiResponse = unknown;
export type DisableAppAccessAsAaApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** id of the User to perform action with. */
  userId: number;
};
export type CreateLoginLessAndAssignPinInApartmentApiResponse = unknown;
export type CreateLoginLessAndAssignPinInApartmentApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  createLoginLessAssignPinRequest: CreateLoginLessAssignPinRequest;
};
export type CreateStandardUserInApartmentOfApartmentAdminApiResponse =
  /** status 200 successful operation */ CreateUserInApartmentResponse;
export type CreateStandardUserInApartmentOfApartmentAdminApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  createUserInApartmentAsApartmentAdminRequest: CreateUserInApartmentAsApartmentAdminRequest;
};
export type CreateGuestAndAssignPinInApartmentApiResponse = unknown;
export type CreateGuestAndAssignPinInApartmentApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  createGuestAssignPinRequest: CreateGuestAssignPinRequest;
};
export type UpdateSiteCredentialsApiResponse = unknown;
export type UpdateSiteCredentialsApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  patchSiteCredentialsRequest: PatchSiteCredentialsRequest;
};
export type ValidateNewHipmoDeviceInApartmentApiResponse = unknown;
export type ValidateNewHipmoDeviceInApartmentApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
};
export type CheckUserExistenceInSiteOfApartmentApiResponse = unknown;
export type CheckUserExistenceInSiteOfApartmentApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** Return the email query param. */
  email?: string;
};
export type GetSiteBasicInfoListApiResponse = /** status 200 successful operation */ SiteBasicInfo[];
export type GetSiteBasicInfoListApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
};
export type ListSiteUsersWithGroupsApiResponse = /** status 200 successful operation */ UserWithGroupsResponse[];
export type ListSiteUsersWithGroupsApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
};
export type GetCreditCostUntilEndOfMonthApiResponse = /** status 200 successful operation */ CreditCost;
export type GetCreditCostUntilEndOfMonthApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Number of licences to estimate credit cost for. If omitted, the number of devices/apartments not covered by existing licences is used. */
  licencesCount?: number;
};
export type ListGroupUsersApiResponse = /** status 200 successful operation */ GroupUsers;
export type ListGroupUsersApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** id of the group */
  groupId: string;
  /** Maximum number of records to be returned. Default 50, maximum 1000 */
  limit?: number;
  /** Name of the attribute to sort the results with. If it is prepended with '-', the order is reversed. Order columns [name, email, firstName, lastName, dateCreated, enabled]  */
  order?: string[];
  /** Return the results with this offset, first record has zero offset. */
  offset?: number;
};
export type GetSiteFeaturesApiResponse = /** status 200 successful operation */ SiteFeaturesResponse;
export type GetSiteFeaturesApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
};
export type ElevatorIntegrationFloorMappingApiResponse =
  /** status 200 successful operation */ ElIntEnrichedFloorMapping;
export type ElevatorIntegrationFloorMappingApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
};
export type CountContactButtonsForDeviceApiResponse =
  /** status 200 number of buttons and their their highest index */ ButtonsCount;
export type CountContactButtonsForDeviceApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric id of a Device to perform action with. */
  deviceId: number;
};
export type GetSiteTypeChangePrecheckApiResponse = /** status 200 successful operation */ ChangeSiteTypeChecksResponse;
export type GetSiteTypeChangePrecheckApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** site type to which the site should be changed */
  siteType: SiteType;
};
export type GetDevicesWithBleSupportedApiResponse = /** status 200 successful operation */ DeviceWithBleSupported[];
export type GetDevicesWithBleSupportedApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
};
export type ListApartmentUsersApiResponse = /** status 200 successful operation */ ApartmentUserList;
export type ListApartmentUsersApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** Text to filter the results with. Filter columns [id, uuid, email, firstName, lastName] */
  filter?: string;
  /** Maximum number of records to be returned. Default 50, maximum 1000 */
  limit?: number;
  /** Name of the attribute to sort the results with. If it is prepended with '-', the order is reversed. Order columns [name, email, firstName, lastName, dateCreated, enabled]  */
  order?: string[];
  /** Return the results with this offset, first record has zero offset. */
  offset?: number;
};
export type GetDefaultApiResponse = /** status 200 successful operation */ BannerInfo;
export type GetDefaultApiArg = void;
export type ListApartmentUsersByApartmentAdminGroupedByApartmentApiResponse =
  /** status 200 successful operation */ ApartmentInfoWithUsersList[];
export type ListApartmentUsersByApartmentAdminGroupedByApartmentApiArg = void;
export type CreatePinWithoutAccessApiResponse = /** status 200 created Pin */ PinValueDto;
export type CreatePinWithoutAccessApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
};
export type CreateGuestPinWithoutAccessApiResponse = /** status 200 created Pin */ PinValueDto;
export type CreateGuestPinWithoutAccessApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
};
export type GetApartmentDetailForAaApiResponse = /** status 200 successful operation */ ApartmentDetailResponse;
export type GetApartmentDetailForAaApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
};
export type DeleteContactButtonsOfDeviceApiResponse = unknown;
export type DeleteContactButtonsOfDeviceApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric id of a Device to perform action with. */
  deviceId: number;
  /** button linkingId */
  linkingId: string;
};
export type DeleteApartmentUserByIdApiResponse = unknown;
export type DeleteApartmentUserByIdApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Numeric apartmentId of the Apartment to perform action with. */
  apartmentId: number;
  /** id of the User to perform action with. */
  userId: number;
};
export type UserRole =
  | 'SITE_USER'
  | 'SITE_ADMIN'
  | 'SITE_ADMIN_PAYMENT'
  | 'COMPANY_ADMIN'
  | 'LOGIN_LESS'
  | 'GUEST'
  | 'PMS_LOGIN_LESS';
export type UserGsmCallsApartmentSetting = {
  apartmentId: number;
  phoneNumber?: string;
  gsmCalls: boolean;
};
export type SiteUserWithLocaleResponse = {
  locale: string;
  enabled: boolean;
  apartments: number[];
  role: UserRole;
  email?: string;
  firstName?: string;
  lastName: string;
  id: number;
  uuid: string;
  phoneNumber?: string;
  gsmCalls?: boolean;
  gsmCallsInApartments?: UserGsmCallsApartmentSetting[];
};
export type SiteUserWithLocaleRequest = {
  locale: string;
  apartments: number[];
  role: UserRole;
  email?: string;
  firstName?: string;
  lastName: string;
  phoneNumber?: string;
  gsmCalls?: boolean;
  gsmCallsInApartments?: UserGsmCallsApartmentSetting[];
};
export type EditGuestRequest = {
  validTo?: string;
  validFrom?: string;
  site?: string;
  emails?: string[];
  apartmentAccess?: boolean;
  pin: string;
  lastName: string;
};
export type DeviceUnlockOverApiResponse = {
  active?: boolean;
};
export type SetDeviceUnlockOverApiServiceRequest = {
  active: boolean;
};
export type ContactResponse = {
  id: number;
  description: string;
  name?: string;
  email?: string;
  phoneNumber?: string;
  note?: string;
};
export type CoreEntityContact = {
  description: string;
  name?: string;
  email?: string;
  phoneNumber?: string;
  note?: string;
};
export type Service =
  | 'ACS'
  | 'MOBILE_VIDEO'
  | 'RAC'
  | 'LOCAL_CALLS'
  | 'GSM_CALLS'
  | 'NOTIFICATION'
  | 'REMOTE_CONFIGURATION'
  | 'INTERCOM_MONITORING'
  | 'REMOTE_API_ACCESS'
  | 'CREDENTIALS';
export type AcsService = {
  type: Service;
  timezone?: string;
  id: number;
  externalId?: string;
};
export type MobileVideoServiceProxy = {
  host?: string;
  port?: number;
  sipsPort?: number;
};
export type LicenceModelBillingType = 'PER_DEVICE' | 'PER_APARTMENT';
export type MobileVideoLicenceModel = {
  id: number;
  billingType: LicenceModelBillingType;
  licencesLimit: number;
  unlicensedCount: number;
  licensedCount: number;
  maximalLicencesLimit: number;
  paidCount: number;
  type: string;
};
export type ActivableMobileVideoLicenceModelState = 'ENABLED' | 'DISABLED';
export type ActivableMobileVideoLicenceModel = MobileVideoLicenceModel & {
  status?: ActivableMobileVideoLicenceModelState;
};
export type ExpirableMobileVideoLicenceModelState = 'ACTIVE' | 'EXPIRED';
export type ExpirableMobileVideoLicenceExtension = {
  id: number;
  period: string;
  dateCreated: string;
  validityFrom: string;
  validityTo: string;
};
export type ExpirableMobileVideoLicenceModel = MobileVideoLicenceModel & {
  validityFrom?: string;
  validityTo?: string;
  billingTypeMultiplier?: number;
  status?: ExpirableMobileVideoLicenceModelState;
  extensions?: ExpirableMobileVideoLicenceExtension[];
};
export type StandardMobileVideoLicenceState =
  | 'INITIAL'
  | 'TRIAL_ACTIVE'
  | 'TRIAL_EXPIRED'
  | 'STANDARD'
  | 'STANDARD_EXPIRED'
  | 'STANDARD_RENEWAL'
  | 'TEMPORARY';
export type MobileVideoProduct =
  | 'MOBILE_VIDEO_MONTH'
  | 'MOBILE_VIDEO_YEAR'
  | 'APARTMENT_MOBILE_VIDEO_MONTH'
  | 'APARTMENT_MOBILE_VIDEO_YEAR'
  | 'MOBILE_VIDEO_UNLIMITED';
export type MobileVideoProductPurchaseCalculation = {
  unitFullPrice?: number;
  unitFullPriceVat?: number;
  chargeVat?: boolean;
  purchase?: number;
  percentage?: number;
  multiplier?: number;
  licencesPool?: number;
  licences?: number;
  price?: number;
  priceVat?: number;
};
export type NextPayment = {
  date?: string;
  calculation?: MobileVideoProductPurchaseCalculation;
};
export type StandardMobileVideoLicenceModel = MobileVideoLicenceModel & {
  validityFrom?: string;
  validityTo?: string;
  status?: StandardMobileVideoLicenceState;
  product?: MobileVideoProduct;
  billingTypeMultiplier?: number;
  consumptionMultiplier?: number;
  combinedMultiplier?: number;
  licencesPool?: number;
  freeLicencesWithIntercomCount?: number;
  unusedFreeLicencesWithIntercomCount?: number;
  unusedLicencesCount?: number;
  allPaidLicencesCoveredByFreeLicences?: boolean;
  requirePaymentCount?: number;
  poolExpiration?: string;
  nextPayment?: NextPayment;
  additional?: number;
  extensions?: ExpirableMobileVideoLicenceExtension[];
};
export type MobileVideoService = {
  type: Service;
  phonePrefix: string;
  deviceLimit: number;
  ringingGroupSizeLimit: number;
  proxy: MobileVideoServiceProxy;
  licenceModel:
    | MobileVideoLicenceModel
    | ActivableMobileVideoLicenceModel
    | ExpirableMobileVideoLicenceModel
    | StandardMobileVideoLicenceModel;
  sipsEnabled?: boolean;
  srtpEnabled?: boolean;
  id: number;
  externalId?: string;
};
export type LocalCallsService = {
  type: Service;
  id: number;
  externalId?: string;
};
export type GsmCallsService = {
  type: Service;
  active?: boolean;
  id: number;
  externalId?: string;
};
export type NotificationService = {
  type: Service;
  id: number;
  externalId?: string;
};
export type RemoteConfigurationService = {
  type: Service;
  id: number;
  externalId?: string;
};
export type IntercomMonitoringService = {
  type: Service;
  id: number;
  externalId?: string;
};
export type RemoteApiAccessService = {
  type: Service;
  id: number;
  externalId?: string;
};
export type CredentialsService = {
  type: Service;
  id: number;
  externalId?: string;
};
export type RacService = {
  type: Service;
  id: number;
  externalId?: string;
};
export type SiteBluetoothManagementState =
  | 'UNDECIDED'
  | 'NOT_MANAGED'
  | 'MANAGED'
  | 'MANAGED_INCLUDING_OFFLINE'
  | 'RECONFIGURATION_REQUIRED';
export type AccessControlService = {
  guestPinLength: number;
  guestShowQr: boolean;
  bluetoothEnabled?: boolean;
  bluetoothManagementState: SiteBluetoothManagementState;
};
export type SiteServicesWithAccessControlService = {
  ACS?: AcsService;
  MOBILE_VIDEO?: MobileVideoService;
  LOCAL_CALLS?: LocalCallsService;
  GSM_CALLS?: GsmCallsService;
  NOTIFICATION?: NotificationService;
  REMOTE_CONFIGURATION?: RemoteConfigurationService;
  INTERCOM_MONITORING?: IntercomMonitoringService;
  REMOTE_API_ACCESS?: RemoteApiAccessService;
  CREDENTIALS?: CredentialsService;
  RAC?: RacService;
  ACCESS_CONTROL: AccessControlService;
};
export type SiteType = 'SINGLE_VILLA' | 'MDU' | 'OTHER' | 'UNKNOWN' | 'FAMILY_HOME' | 'MIXED_USE' | 'OFFICE';
export type SiteRoles = {
  ADMIN?: number[];
  USER?: number[];
};
export type SiteCategory = 'RESIDENTIAL' | 'COMMERCIAL' | 'DEPRECATED';
export type SiteFeature =
  | 'APARTMENT_ADMIN'
  | 'FREE_MV_LICENCES_WITH_INTERCOM'
  | 'NON_INTERCOM_DEVICE_FORBIDDEN_OUTSIDE_APARTMENT'
  | 'FREE_APARTMENT_SERVICES_WITH_ANSWERING_UNIT';
export type SiteAddress = {
  countryCode: string;
  state?: string;
  city?: string;
  street?: string;
  postalCode?: string;
  timezone: string;
};
export type SiteWithAcCredentialsSettingsResponse = {
  services: SiteServicesWithAccessControlService;
  externalId?: string;
  my2nId: string;
  type: SiteType;
  apartmentDeviceLimit: number;
  dateCreated: string;
  lastEventDate?: string;
  locale: string;
  roles: SiteRoles;
  siteCategory: SiteCategory;
  siteFeatures: SiteFeature[];
  address?: SiteAddress;
  contacts: ContactResponse[];
  id: number;
  name: string;
  gsmCalls?: boolean;
};
export type ServicesFromCore = {
  ACS?: AcsService;
  MOBILE_VIDEO?: MobileVideoService;
  LOCAL_CALLS?: LocalCallsService;
  GSM_CALLS?: GsmCallsService;
  NOTIFICATION?: NotificationService;
  REMOTE_CONFIGURATION?: RemoteConfigurationService;
  INTERCOM_MONITORING?: IntercomMonitoringService;
  REMOTE_API_ACCESS?: RemoteApiAccessService;
  CREDENTIALS?: CredentialsService;
  RAC?: RacService;
};
export type CoreSite = {
  services: ServicesFromCore;
  externalId?: string;
  my2nId: string;
  type: SiteType;
  apartmentDeviceLimit: number;
  dateCreated: string;
  lastEventDate?: string;
  locale: string;
  roles: SiteRoles;
  siteCategory: SiteCategory;
  siteFeatures: SiteFeature[];
  address?: SiteAddress;
  contacts: ContactResponse[];
  id: number;
  name: string;
  gsmCalls?: boolean;
};
export type UpdateSiteRequest = {
  name?: string;
  type?: SiteType;
  locale?: string;
  address?: SiteAddress;
};
export type ApartmentUserRole =
  | 'APARTMENT_ADMIN_INHERITED'
  | 'APARTMENT_ADMIN'
  | 'APARTMENT_USER'
  | 'APARTMENT_LOGIN_LESS'
  | 'APARTMENT_GUEST'
  | 'APARTMENT_PMS_LOGIN_LESS';
export type RacCredentialsType = 'PIN' | 'RFID' | 'BT' | 'LPR';
export type ApartmentUserWithCredentials = {
  role: ApartmentUserRole;
  locale: string;
  enabled: boolean;
  validFrom?: string;
  validTo?: string;
  credentials: RacCredentialsType[];
  email?: string;
  firstName?: string;
  lastName: string;
  id: number;
  uuid: string;
  phoneNumber?: string;
  gsmCalls?: boolean;
};
export type ApartmentMobileVideoState =
  | 'ACTIVE_FOR_FREE'
  | 'NO_SERVICE'
  | 'ACTIVE_SUBSCRIPTIONS'
  | 'UNLICENSED'
  | 'OTHER';
export type ApartmentPaidServicesStatus =
  | 'INACTIVE'
  | 'REQUESTED_ACTIVATION'
  | 'ACTIVE'
  | 'ACTIVE_FOR_FREE_WITH_ANSWERING_UNIT';
export type ApartmentWithMobileVideoStateAndDevicesCount = {
  apartmentMobileVideoState: ApartmentMobileVideoState;
  bluetoothEnabled: boolean;
  paidServicesActive?: boolean;
  paidServicesStatus?: ApartmentPaidServicesStatus;
  id: number;
  name?: string;
  number: string;
  devicesCount: number;
  paidDevicesCount: number;
  paidDevicesLimit: number;
};
export type SiteUserWithLocaleAndApartmentResponse = {
  user: ApartmentUserWithCredentials;
  apartment: ApartmentWithMobileVideoStateAndDevicesCount;
};
export type UpdateUserBasicInfoInApartmentResponse = {
  role: ApartmentUserRole;
  locale: string;
  enabled: boolean;
  validFrom?: string;
  validTo?: string;
  credentials: RacCredentialsType[];
  email?: string;
  firstName?: string;
  lastName: string;
  id: number;
  uuid: string;
  phoneNumber?: string;
  gsmCalls?: boolean;
};
export type UserModifyNameRequest = {
  firstName?: string;
  lastName: string;
};
export type ApartmentLabelRequest = {
  label: string;
};
export type UserCompletedSurveysResponse = {
  surveyNames: string[];
};
export type UserAnsweredSurveyRequest = {
  surveyName: string;
};
export type Apartment = {
  id: number;
  name?: string;
  number: string;
};
export type UserWithApartmentsAndCredentials = {
  validFrom?: string;
  validTo?: string;
  credentials: RacCredentialsType[];
  enabled: boolean;
  apartments: Apartment[];
  role: UserRole;
  email?: string;
  firstName?: string;
  lastName: string;
  id: number;
  uuid: string;
};
export type SiteUserList = {
  users: UserWithApartmentsAndCredentials[];
  resultsFiltered: number;
  resultsTotal: number;
  offset: number;
  limit: number;
};
export type SiteUserRequestImpl = {
  apartments: number[];
  role: UserRole;
  email?: string;
  firstName?: string;
  lastName: string;
  phoneNumber?: string;
  gsmCalls?: boolean;
};
export type ContactItem = {
  id: number;
  externalId?: string;
  type: string;
};
export type ApartmentContactItem = ContactItem & {
  apartmentId?: number;
  sipNumber?: string;
};
export type GsmCallsContactItem = ContactItem & {
  deviceConfigId?: number;
  gatewayId?: number;
};
export type LocalCallsContactItem = ContactItem & {
  deviceConfigId?: number;
};
export type MobileVideoContactItem = ContactItem & {
  deviceConfigId?: number;
};
export type GsmFallback = {
  deviceConfigId: number;
  gatewayId: number;
};
export type RingingGroupContactItem = ContactItem & {
  gsmFallback?: GsmFallback;
  members?: number[];
  sipNumber?: string;
};
export type Contact = {
  id: number;
  externalId?: string;
  name: string;
  virtualNumber?: string;
  contactItems: (
    | ContactItem
    | ApartmentContactItem
    | GsmCallsContactItem
    | LocalCallsContactItem
    | MobileVideoContactItem
    | RingingGroupContactItem
  )[];
};
export type ButtonWithContactsResponse = {
  linkingId: string;
  displayButtonName?: string;
  buttonConfigurationButtonName?: string;
  idx?: number;
  displayButtonId?: number;
  buttonConfigurationButtonId?: number;
  displayButtonExternalId?: string;
  buttonConfigurationButtonExternalId?: string;
  displayId?: number;
  buttonConfigurationId?: number;
  contacts: Contact[];
};
export type ButtonsWithContactsResponse = {
  contactListId: number;
  buttons: ButtonWithContactsResponse[];
};
export type IntercomContactItemRequest = {
  id?: number;
  externalId?: string;
  type: string;
};
export type ApartmentIntercomContactItemRequest = IntercomContactItemRequest & {
  apartmentId?: number;
};
export type GsmCallsIntercomContactItemRequest = IntercomContactItemRequest & {
  deviceConfigId?: number;
  gatewayId?: number;
};
export type LocalCallsIntercomContactItemRequest = IntercomContactItemRequest & {
  deviceConfigId?: number;
};
export type MobileVideoIntercomContactItemRequest = IntercomContactItemRequest & {
  deviceConfigId?: number;
};
export type RingingGroupIntercomContactItemRequest = IntercomContactItemRequest & {
  members?: number[];
  gsmFallback?: GsmFallback;
};
export type IntercomContactRequest = {
  id?: number;
  externalId?: string;
  name: string;
  virtualNumber?: string;
  contactItems: (
    | IntercomContactItemRequest
    | ApartmentIntercomContactItemRequest
    | GsmCallsIntercomContactItemRequest
    | LocalCallsIntercomContactItemRequest
    | MobileVideoIntercomContactItemRequest
    | RingingGroupIntercomContactItemRequest
  )[];
};
export type ButtonConfigurationButtonRequest = {
  index: number;
  id?: number;
  externalId?: string;
  name: string;
};
export type DisplayButtonRequest = {
  id?: number;
  externalId?: string;
  name: string;
};
export type CallSettingsRequest = {
  contacts: IntercomContactRequest[];
  buttonConfigurationButton: ButtonConfigurationButtonRequest;
  displayButton: DisplayButtonRequest;
};
export type CreateGuestAssignPinRequest = {
  validTo?: string;
  validFrom?: string;
  site?: string;
  emails?: string[];
  apartmentAccess?: boolean;
  pin: string;
  lastName: string;
};
export type LoginLessUser = {
  lastName: string;
};
export type LoginLessUserBulkRequest = {
  generatePin: boolean;
  users: LoginLessUser[];
};
export type CreateSiteRequest = {
  name: string;
  type: SiteType;
  locale: string;
  address: SiteAddress;
};
export type UserNameWithEmail = {
  email?: string;
  firstName?: string;
  lastName: string;
};
export type PinDto = {
  id?: string;
  pin?: string;
  active?: boolean;
  link?: string;
};
export type CreateLoginLessAssignPinRequest = {
  pin: string;
  lastName: string;
};
export type CreateUserInApartmentResponse = {
  role: ApartmentUserRole;
  locale: string;
  enabled: boolean;
  validFrom?: string;
  validTo?: string;
  credentials: RacCredentialsType[];
  email?: string;
  firstName?: string;
  lastName: string;
  id: number;
  uuid: string;
  phoneNumber?: string;
  gsmCalls?: boolean;
};
export type CreateUserInApartmentAsApartmentAdminRequest = {
  mobileVideoActivated: boolean;
  appAccessActivated: boolean;
  phoneNumber?: string;
  gsmCalls?: boolean;
  email?: string;
  firstName?: string;
  lastName: string;
};
export type PatchSiteCredentialsRequest = {
  bluetoothManagementState: SiteBluetoothManagementState;
  deviceId?: string;
};
export type SiteBasicInfo = {
  id: number;
  name: string;
  my2nId?: string;
  siteType: SiteType;
  siteCategory: SiteCategory;
  roles?: SiteRoles;
};
export type UserWithGroupsResponse = {
  groups: string[];
  apartments: Apartment[];
  enabled: boolean;
  role: UserRole;
  email?: string;
  firstName?: string;
  lastName: string;
  id: number;
  uuid: string;
};
export type CreditCost = {
  creditsNeeded: number;
  licencesCount: number;
};
export type Group = {
  description?: string;
  id: string;
  name: string;
};
export type UserWithApartmentsAndGroupsAndCredentials = {
  groups: Group[];
  validFrom?: string;
  validTo?: string;
  credentials: RacCredentialsType[];
  enabled: boolean;
  apartments: Apartment[];
  role: UserRole;
  email?: string;
  firstName?: string;
  lastName: string;
  id: number;
  uuid: string;
};
export type GroupUsers = {
  groupUsers?: UserWithApartmentsAndGroupsAndCredentials[];
  resultsFiltered: number;
  resultsTotal: number;
  offset: number;
  limit: number;
};
export type SiteFeaturesResponse = {
  siteId?: number;
  siteName?: string;
  siteFeatures?: SiteFeature[];
  siteCategory: SiteCategory;
  billingType?: LicenceModelBillingType;
  apartmentStatesCounts: {
    [key: string]: number;
  };
};
export type ElIntDestination = {
  areaId: string;
  shortName: string;
};
export type ElIntElevatorGroup = {
  id: string;
  name: string;
  destinations: ElIntDestination[];
};
export type ElIntBuilding = {
  id: string;
  elevatorGroups: ElIntElevatorGroup[];
};
export type ElIntBuildingTopology = {
  buildings: ElIntBuilding[];
};
export type ElIntFloor = {
  id: string;
  name: string;
};
export type ElIntStop = {
  buildingId: string;
  elevatorGroupId: string;
  areaId: string;
};
export type ElIntSingleFloorMapping = {
  floorId: string;
  mappings: ElIntStop[];
};
export type ElIntFloorMapping = {
  floors: ElIntSingleFloorMapping[];
};
export type ElIntEnrichedFloorMapping = {
  buildingTopology: ElIntBuildingTopology;
  floors: ElIntFloor[];
  floorMapping: ElIntFloorMapping;
};
export type ButtonsCount = {
  count: number;
  maxIndex?: number;
};
export type ChangeSiteTypeChecksResponse = {
  fromCategory: SiteCategory;
  toCategory: SiteCategory;
  fromType: SiteType;
  toType: SiteType;
  enabledFeatures: SiteFeature[];
  failedToEnableFeatures: SiteFeature[];
  defaultApartmentDeviceLimit: number;
  actualApartmentDeviceLimit: number;
  canChangeSiteType: boolean;
};
export type DeviceWithBleSupported = {
  id: string;
  name?: string;
  type: string;
  sn: string;
  bleSupported: boolean;
};
export type UserWithApartmentsAndCredentialsAndAdminFlag = {
  admin: boolean;
  validFrom?: string;
  validTo?: string;
  credentials: RacCredentialsType[];
  enabled: boolean;
  apartments: Apartment[];
  role: UserRole;
  email?: string;
  firstName?: string;
  lastName: string;
  id: number;
  uuid: string;
};
export type ApartmentUserList = {
  users: UserWithApartmentsAndCredentialsAndAdminFlag[];
  resultsFiltered: number;
  resultsTotal: number;
  offset: number;
  limit: number;
};
export type BannerInfo = {
  id?: string;
  title?: string;
  message: string;
  validFrom?: string;
  validTo?: string;
};
export type ApartmentUserWithCredentialsAndMvStatus = {
  mobileVideoActivated: boolean;
  role: ApartmentUserRole;
  locale: string;
  enabled: boolean;
  validFrom?: string;
  validTo?: string;
  credentials: RacCredentialsType[];
  email?: string;
  firstName?: string;
  lastName: string;
  id: number;
  uuid: string;
  phoneNumber?: string;
  gsmCalls?: boolean;
};
export type SiteInfo1 = {
  id: number;
  name: string;
  gsmCalls?: boolean;
};
export type CompanyInfo = {
  id: number;
};
export type ApartmentInfoWithUsersList = {
  contactLabels: string[];
  users: ApartmentUserWithCredentialsAndMvStatus[];
  site: SiteInfo1;
  company: CompanyInfo;
  apartmentMobileVideoState: ApartmentMobileVideoState;
  bluetoothEnabled: boolean;
  paidServicesActive?: boolean;
  paidServicesStatus?: ApartmentPaidServicesStatus;
  id: number;
  name?: string;
  number: string;
  devicesCount: number;
  paidDevicesCount: number;
  paidDevicesLimit: number;
};
export type PinValueDto = {
  pin?: string;
};
export type ApartmentDetailResponse = {
  siteName: string;
  gsmCalls?: boolean;
  usersCount: number;
  accessGroupNames?: string[];
  contactLabels: string[];
  apartmentMobileVideoState: ApartmentMobileVideoState;
  bluetoothEnabled: boolean;
  paidServicesActive?: boolean;
  paidServicesStatus?: ApartmentPaidServicesStatus;
  id: number;
  name?: string;
  number: string;
  devicesCount: number;
  paidDevicesCount: number;
  paidDevicesLimit: number;
};
export const {
  useApartmentAdminDeleteApartmentUserByIdMutation,
  useBulkCreateLoginLessUserMutation,
  useCheckUserExistenceInSiteOfApartmentMutation,
  useCountContactButtonsForDeviceQuery,
  useCreateGuestAndAssignPinInApartmentMutation,
  useCreateGuestAndAssignPinInSiteMutation,
  useCreateGuestPinWithoutAccessQuery,
  useCreateLoginLessAndAssignPinInApartmentMutation,
  useCreatePinProposalForUserMutation,
  useCreatePinWithoutAccessQuery,
  useCreateSiteContactMutation,
  useCreateSiteMutation,
  useCreateSiteUserMutation,
  useCreateStandardUserInApartmentOfApartmentAdminMutation,
  useCreateUpdateContactButtonsForDeviceMutation,
  useDeleteApartmentUserByIdMutation,
  useDeleteContactButtonsOfDeviceMutation,
  useDeleteSiteContactByIdMutation,
  useDeleteSiteUserByIdMutation,
  useDisableAppAccessAsAaMutation,
  useEditGuestInApartmentMutation,
  useEditGuestInSiteMutation,
  useElevatorIntegrationFloorMappingQuery,
  useEnableAppAccessAsAaMutation,
  useGetAllUserCompletedSurveyNamesQuery,
  useGetApartmentDetailForAaQuery,
  useGetApartmentUserForAaByIdQuery,
  useGetCreditCostUntilEndOfMonthQuery,
  useGetDefaultQuery,
  useGetDevicesWithBleSupportedQuery,
  useGetSiteBasicInfoListQuery,
  useGetSiteFeaturesQuery,
  useGetSiteQuery,
  useGetSiteTypeChangePrecheckQuery,
  useGetSiteUserByIdQuery,
  useGetUnlockOverApiForDeviceQuery,
  useLazyCountContactButtonsForDeviceQuery,
  useLazyCreateGuestPinWithoutAccessQuery,
  useLazyCreatePinWithoutAccessQuery,
  useLazyElevatorIntegrationFloorMappingQuery,
  useLazyGetAllUserCompletedSurveyNamesQuery,
  useLazyGetApartmentDetailForAaQuery,
  useLazyGetApartmentUserForAaByIdQuery,
  useLazyGetCreditCostUntilEndOfMonthQuery,
  useLazyGetDefaultQuery,
  useLazyGetDevicesWithBleSupportedQuery,
  useLazyGetSiteBasicInfoListQuery,
  useLazyGetSiteFeaturesQuery,
  useLazyGetSiteQuery,
  useLazyGetSiteTypeChangePrecheckQuery,
  useLazyGetSiteUserByIdQuery,
  useLazyGetUnlockOverApiForDeviceQuery,
  useLazyListApartmentUsersByApartmentAdminGroupedByApartmentQuery,
  useLazyListApartmentUsersQuery,
  useLazyListContactButtonsForDeviceQuery,
  useLazyListGroupUsersQuery,
  useLazyListSiteUsersQuery,
  useLazyListSiteUsersWithGroupsQuery,
  useListApartmentUsersByApartmentAdminGroupedByApartmentQuery,
  useListApartmentUsersQuery,
  useListContactButtonsForDeviceQuery,
  useListGroupUsersQuery,
  useListSiteUsersQuery,
  useListSiteUsersWithGroupsQuery,
  useMarkSurveyAsAnsweredForUserMutation,
  useMigrateUserAsApartmentAdminMutation,
  useMigrateUserWithAppAccessActivationMutation,
  useMigrateUserWithDeviceActivationMutation,
  useModifySiteUserByIdMutation,
  useNotifyUserMfaEnabledMutation,
  useSetDeviceUnlockOverApiServiceMutation,
  useUpdateApartmentLabelMutation,
  useUpdateSiteContactByIdMutation,
  useUpdateSiteCredentialsMutation,
  useUpdateSiteMutation,
  useUpdateUserBasicInfoInApartmentMutation,
  useValidateNewHipmoDeviceInApartmentMutation,
} = injectedRtkApi;
